// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.3.5-0-g878d99c9",
    "hash": "g878d99c9",
    "distance": 0,
    "tag": "v1.3.5",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.3.5",
        "major": 1,
        "minor": 3,
        "patch": 5,
        "prerelease": [],
        "build": [],
        "version": "1.3.5"
    },
    "suffix": "0-g878d99c9",
    "semverString": "1.3.5",
    "version": "1.3.5"
};
